import React, { useState, useEffect, useRef } from "react";
import styles from "../EditDiv/EditDiv.module.css";
import buttonStyles from "../YesNoButtonsCSS/YesNoButtons.module.css";
import BlueLogo from "../../assets/BlueLogo.png";
import { Box, Grid, TextField, CircularProgress } from "@mui/material";
import { useDispatch, useSelector } from "../../redux/store";
import Dropdown from "../DropDownBox/Dropdown";
import DropDownV2 from "../DropDownBox/DropdownV2";
import { Form, FormikProvider } from "formik";
import { useFormik } from "formik";
import * as Yup from "yup";
import textfieldStyle from "../../GlobalStyles/styles";
import { searchClientsForAttachment } from "../../redux/slices/client";

const ClientForm = ({ Name, onSubmit, onClose }) => {
  const dispatch = useDispatch();
  const { runners } = useSelector((state) => state.opportunities);
  const { attachProfessionalOptions } = useSelector((state) => state.client);

  const modifiedRunners = [{ label: "N/A", value: 999 }, ...runners];
  const backdropRef = useRef(null);
  const formRef = useRef(null);

  const handleFormClick = (e) => {
    e.stopPropagation();
  };

  // Ensure modal opens scrolled to the top and content is top-aligned
  useEffect(() => {
    if (backdropRef.current) backdropRef.current.scrollTop = 0;
    if (formRef.current) formRef.current.scrollTop = 0;
  }, []);

  const preferredOptions = [
    { label: "Work with - Preferred", value: "Work with - Preferred" },
    { label: "Work with - Not Preferred", value: "Work with - Not Preferred" },
    { label: "Do not work with", value: "Do not work with" },
  ];

  const professionOptions = [
    { label: "Architect", value: "Architect" },
    { label: "Contractor", value: "Contractor" },
    { label: "Developer", value: "Developer" },
  ];

  const initialValues = {
    company: Name,
    runnerName: "",
    runnerID:"",
    email: "",
    phoneNumber: "",
    addressOne: "",
    addressTwo: "",
    town: "", // City field removed, only Town remains
    postcode: "",
    comment: "",
    clientTypes: "",
    profession: "",
    preferred: "",
    linkedCompanyID: "",
    linkedCompanyName: "",
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: newClientSchema,
    onSubmit: async (values, { resetForm }) => {
      onSubmit(values);
      onClose();
    },
  });
  const { getFieldProps, touched, errors, handleSubmit, values, setFieldValue } = formik;

  const handleProfessionalSearchChange = (searchTerm) => {
    if (!searchTerm) return;
    dispatch(searchClientsForAttachment(searchTerm, "professional"));
  };

  return (
    <div
      className={styles.backGround}
      ref={backdropRef}
    >
      <div
        className={styles.form}
        ref={formRef}
        style={{
          width: "500px",
          maxHeight: "80vh",
          overflowY: "auto",
          justifyContent: "flex-start",
          alignItems: "stretch",
          paddingTop: 12,
          paddingBottom: 8,
        }}
        onClick={handleFormClick}
      >
        <div className={styles.momentTitle}>MOMENT</div>
        <div className={styles.sectionTitle}>New Client</div>

        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit} style={{ width: "100%" }}>
            <Grid container sx={{ width: "100%" }}>
              <Grid item xs={3} sx={{ pr: 3 }}>
                <p className={styles.dataTitleV2}>Company: </p>
              </Grid>
              <Grid item xs={9} sx={{ mt: 1 }}>
                <TextField
                  fullWidth
                  {...getFieldProps("company")}
                  placeholder="Company"
                  sx={textfieldStyle}
                  error={Boolean(touched.company && errors.company)}
                />
              </Grid>
            </Grid>
            <Grid container sx={{ width: "100%", mt: 2 }}>
              <Grid item xs={3} sx={{ pr: 3 }}>
                <p className={styles.dataTitleV2} style={{ pb: 0, mb: 0 }}>
                  Preferred Runner:{" "}
                </p>
              </Grid>
              <Grid item xs={9} sx={{ mt: 1.5 }}>
                <DropDownV2
                  options={modifiedRunners}
                  initialSelectedValue={
                    modifiedRunners.find(
                      (o) =>
                        o.value === formik.values.runnerID ||
                        o.label === formik.values.runnerName
                    ) || {}
                  }
                  placeholder={"Select Preffered Runner"}
                  onValueChange={(newValue) => {
                    formik.setFieldValue("runnerName", newValue.label);
                    formik.setFieldValue("runnerID", newValue.value);
                  }}
                  errorState={Boolean(
                    touched.runnerName && errors.runnerName
                  )}
                />
              </Grid>
            </Grid>
            <Grid container sx={{ width: "100%", mt: 2 }}>
              <Grid item xs={3} sx={{ pr: 3 }}>
                <p className={styles.dataTitleV2}>Email Address: </p>
              </Grid>
              <Grid item xs={9} sx={{ mt: 1 }}>
                <TextField
                  fullWidth
                  {...getFieldProps("email")}
                  placeholder="Email Address"
                  sx={textfieldStyle}
                  error={Boolean(touched.email && errors.email)}
                />
              </Grid>
            </Grid>
            <Grid container sx={{ width: "100%", mt: 2 }}>
              <Grid item xs={3} sx={{ pr: 3 }}>
                <p className={styles.dataTitleV2}>Phone No: </p>
              </Grid>
              <Grid item xs={9} sx={{ mt: 1 }}>
                <TextField
                  fullWidth
                  {...getFieldProps("phoneNumber")}
                  placeholder="Phone Number"
                  sx={textfieldStyle}
                />
              </Grid>
            </Grid>
            <Grid container sx={{ width: "100%", mt: 2 }}>
              <Grid item xs={3} sx={{ pr: 3 }}>
                <p className={styles.dataTitleV2}>Address 1: </p>
              </Grid>
              <Grid item xs={9} sx={{ mt: 1 }}>
                <TextField
                  fullWidth
                  {...getFieldProps("addressOne")}
                  placeholder="Address 1"
                  sx={textfieldStyle}
                />
              </Grid>
            </Grid>
            <Grid container sx={{ width: "100%", mt: 2 }}>
              <Grid item xs={3} sx={{ pr: 3 }}>
                <p className={styles.dataTitleV2}>Address 2: </p>
              </Grid>
              <Grid item xs={9} sx={{ mt: 1 }}>
                <TextField
                  fullWidth
                  {...getFieldProps("addressTwo")}
                  placeholder="Address 2"
                  sx={textfieldStyle}
                />
              </Grid>
            </Grid>
            <Grid container sx={{ width: "100%", mt: 2 }}>
              <Grid item xs={3} sx={{ pr: 3 }}>
                <p className={styles.dataTitleV2}>Town: </p>
              </Grid>
              <Grid item xs={9} sx={{ mt: 1 }}>
                <TextField
                  fullWidth
                  {...getFieldProps("town")}
                  placeholder="Town"
                  sx={textfieldStyle}
                />
              </Grid>
            </Grid>
            <Grid container sx={{ width: "100%", mt: 2 }}>
              <Grid item xs={3} sx={{ pr: 3 }}>
                <p className={styles.dataTitleV2}>Post Code: </p>
              </Grid>
              <Grid item xs={9} sx={{ mt: 1 }}>
                <TextField
                  fullWidth
                  {...getFieldProps("postcode")}
                  placeholder="Post Code"
                  sx={textfieldStyle}
                />
              </Grid>
            </Grid>
            <Grid container sx={{ width: "100%", mt: 2 }}>
              <Grid item xs={3} sx={{ pr: 3 }}>
                <p className={styles.dataTitleV2} style={{ pb: 0, mb: 0 }}>
                  Client Type:{" "}
                </p>
              </Grid>
              <Grid item xs={9} sx={{ mt: 1.5 }}>
                <Dropdown
                  options={["Professional", "Home Owner", "Company"]}
                  initialSelectedValue={formik.values.clientTypes}
                  placeholder={"Select Client Types"}
                  onValueChange={(newValue) =>
                    formik.setFieldValue("clientTypes", newValue)
                  }
                  PopUp={true}
                  errorState={Boolean(touched.clientTypes && errors.clientTypes)}
                />
              </Grid>
            </Grid>

            {['Professional', 'Company'].includes(values.clientTypes) && (
              <Grid container sx={{ width: "100%", mt: 2 }}>
                <Grid item xs={3} sx={{ pr: 3 }}>
                  <p className={styles.dataTitleV2} style={{ pb: 0, mb: 0 }}>
                    Profession:{" "}
                  </p>
                </Grid>
                <Grid item xs={9} sx={{ mt: 1.5 }}>
                  <DropDownV2
                    options={professionOptions}
                    initialSelectedValue={
                      professionOptions.find(
                        (o) =>
                          o.value === values.profession ||
                          o.label === values.profession
                      ) || {}
                    }
                    placeholder={"Select Profession"}
                    onValueChange={(newValue) =>
                      setFieldValue("profession", newValue.value)
                    }
                    PopUp={true}
                    errorState={Boolean(touched.profession && errors.profession)}
                  />
                </Grid>
              </Grid>
            )}

            {values.clientTypes === 'Company' && (
              <Grid container sx={{ width: "100%", mt: 2 }}>
                <Grid item xs={3} sx={{ pr: 3 }}>
                  <p className={styles.dataTitleV2} style={{ pb: 0, mb: 0 }}>
                    Primary Professional (optional):
                  </p>
                </Grid>
                <Grid item xs={9} sx={{ mt: 1.5 }}>
                  <DropDownV2
                    options={attachProfessionalOptions}
                    initialSelectedValue={
                      values.linkedCompanyID
                        ? attachProfessionalOptions.find((o) => o.value === values.linkedCompanyID) || {}
                        : {}
                    }
                    placeholder={"Search professional"}
                    onValueChange={(newValue) => {
                      setFieldValue("linkedCompanyID", newValue?.value || "");
                      setFieldValue("linkedCompanyName", newValue?.label || "");
                    }}
                    onSearchChange={handleProfessionalSearchChange}
                    PopUp={true}
                    searchable={true}
                    addNew={false}
                    clientType="professional"
                  />
                </Grid>
              </Grid>
            )}

            <Grid container sx={{ width: "100%", mt: 2 }}>
              <Grid item xs={3} sx={{ pr: 3 }}>
                <p className={styles.dataTitleV2} style={{ pb: 0, mb: 0 }}>
                  Preferred:{" "}
                </p>
              </Grid>
              <Grid item xs={9} sx={{ mt: 1.5 }}>
                <DropDownV2
                  options={preferredOptions}
                  initialSelectedValue={
                    preferredOptions.find(
                      (o) =>
                        o.value === values.preferred ||
                        o.label === values.preferred
                    ) || {}
                  }
                  placeholder={"Select Preferred Status"}
                  onValueChange={(newValue) =>
                    setFieldValue("preferred", newValue.value)
                  }
                  PopUp={true}
                  errorState={Boolean(touched.preferred && errors.preferred)}
                />
              </Grid>
            </Grid>
            
            <Grid container sx={{ width: "100%", mt: 2 }}>
              <Grid item xs={3} sx={{ pr: 3 }}>
                <p className={styles.dataTitleV2} style={{ pb: 0, mb: 0 }}>
                  Comments:{" "}
                </p>
              </Grid>
              <Grid item xs={9} sx={{ mt: 1 }}>
                <TextField
                  fullWidth
                  multiline
                  {...getFieldProps("comment")}
                  rows={2}
                  placeholder="Comment"
                  sx={textfieldStyle}
                  inputProps={{ style: { margin: 0 } }}
                />
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>

        <div className={styles.updateAndCancel}>
          <div className={styles.updateButton} onClick={handleSubmit}>
            <div className={buttonStyles.YesButtonComponentStyling}>SUBMIT</div>
          </div>
          <div className={styles.cancelButton} onClick={onClose}>
            <div className={buttonStyles.NoButtonComponentStyling}>CANCEL</div>
          </div>
        </div>

        <img className={styles.blueLogo} src={BlueLogo} alt="BlueLogo" style={{ alignSelf: 'center' }} />
      </div>
    </div>
  );
};

const newClientSchema = Yup.object().shape({
  company: Yup.string().required("Company name is required"),
  email: Yup.string().email("Invalid email format").required("Email is required"),
  clientTypes: Yup.string().required("Client type is required"),
  runnerName: Yup.string().required("Preferred runner is required"),
  profession: Yup.string().when('clientTypes', {
    is: (val) => ['Professional', 'Company'].includes(val),
    then: (schema) => schema.required('Profession is required'),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export default ClientForm;
